import { PropsWithChildren } from "react";
import clsx from "clsx";

import styles from "./ProductCard.module.scss";
import Card from "../card/Card";
import ProductName from "./ProductName";
import BodyText from "../support/BodyText";
import ProductCardAvailabilityText from "./ProductCardAvailabilityText";
import ProductCardBanner from "./ProductCardBanner";

export type ProductCardProps = PropsWithChildren<{
  productName: string;
  enlargeOnHover?: boolean;
  highlighted?: boolean;
  isOutOfStock?: boolean;
  isProductUnavailable?: boolean;
  withoutImage?: boolean;
}>;

export default function ProductCard({
  productName,
  enlargeOnHover = false,
  highlighted = false,
  isOutOfStock = false,
  isProductUnavailable = false,
  withoutImage = false,
  children,
}: ProductCardProps) {
  const defaultProductCardStyle = false;
  const disabled = isProductUnavailable || isOutOfStock;

  return (
    <Card
      tabIndex={0}
      className={clsx(styles.container, {
        [styles.imageOnTopStyle]: !defaultProductCardStyle,
        [styles.enlargeOnHover]: enlargeOnHover,
        [styles.highlighted]: !!highlighted,
        [styles.disabled]: disabled,
      })}
      disabled={disabled}
      aria-label={productName}
    >
      <div
        className={clsx(styles.infoContainer, {
          [styles.disabled]: disabled,
        })}
      >
        <ProductName as="h3" className={styles.productName}>
          {productName}
        </ProductName>
        <div
          className={clsx(styles.productMetaContainer, {
            [styles.imageOnTopStyle]: !defaultProductCardStyle,
          })}
        >
          <div className={styles.priceContainer}>
            <div className={styles.leftContainer}>
              <BodyText className={styles.productPrice}>140.99 kr</BodyText>
              <BodyText className={styles.pricePresetTag}>Happy Hour</BodyText>

              {isOutOfStock && (
                <BodyText className={styles.outOfStockTag}>
                  Out Of Stock
                </BodyText>
              )}
            </div>
          </div>
          <div className={styles.spaceBetween} />
          {!disabled && (
            <BodyText className={styles.productDescription}>
              Smoked salmon, black rice, avocado, kale, ginger pickled carrots,
              cucumber, fresh parsley, roasted sunflower seeds
            </BodyText>
          )}
          {isProductUnavailable && !isOutOfStock && (
            <ProductCardAvailabilityText />
          )}
        </div>
      </div>
      <ProductCardBanner
        disabled={disabled}
        productName={productName}
        withoutImage={withoutImage}
      />
      {children}
    </Card>
  );
}
